import React, { useState } from "react";
import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import ClaimsRaised from "./ClaimsRaised";
import ClaimsReceived from "./ClaimsReceived";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import { useParams } from "react-router-dom";
import { enterpriseTokens } from "styles/theme";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Grid size={12}>
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
      </div>
    </Grid>
  );
}

export const dashboardOptions = [
  { label: "Claims/Change Received", value: "Claims/Change Received" },
  { label: "Claims/Change Raised", value: "⁠Claims/Change Raised" },
];

const ContractManagementDashboard = () => {

  const { projectId } = useParams();
  const { data: contractData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Grid container spacing={"10px"} sx={{ p: 0, pb: 0 }}>
        <Grid size={12} sx={{ bgcolor: "#fff", p: 2, pt: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
                gap: 1,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "18px", sm: "32px", md: "36px" },
                  lineHeight: { xs: "16px", md: "48px" },
                  color: "#252C32",
                  fontFamily: "Outfit, sans-serif",
                }}
              >
                Commercial Exposure
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "24px",
                color: "#252C32",
                fontFamily: "Outfit, sans-serif",
              }}
            >
              Monitor contract value, claims, change orders, and required commercial action.
            </Typography>
          </Box>
        </Grid>
        <Grid size={12}>
          <Box
            sx={{
              width: "100%",
              borderBottom: "2px solid #ECECEC",
              overflowX: "auto",
              whiteSpace: "nowrap",
              p: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              pl: 2,
              mb: 2,
              boxSizing: "border-box",
              "-webkit-overflow-scrolling": "touch",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              TabIndicatorProps={{ style: { display: "none" } }}
              variant="scrollable"
              scrollButtons={false}
              sx={{
                justifyContent: "flex-start !important",
                alignItems: "flex-start",
                "& .MuiTabs-flexContainer": {
                  justifyContent: "flex-start !important",
                  gap: "30px",
                },
              }}
            >
              {[...dashboardOptions?.map((item) => item?.value)]?.map(
                (label, index) => (
                  <Tab
                    key={index}
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "100%",
                            color: tabValue === index ? "#0E73F6" : "#7E7E7E",
                            fontFamily: "Outfit, sans-serif",
                          }}
                        >
                          {label}
                        </Typography>
                      </Box>
                    }
                    sx={{
                      padding: 0,
                      textTransform: "none",
                      minWidth: "auto",
                      borderBottom:
                        tabValue === index
                          ? "2px solid #0E73F6"
                          : "2px solid transparent",
                    }}
                  />
                )
              )}
            </Tabs>
            <Box sx={{ flexShrink: 0, px: 2, pb: 1, "& .MuiTypography-root": { fontSize: "12px", color: enterpriseTokens.muted } }}>
              <ProjectLastUpdatedOn date={contractData?.contract} />
            </Box>
          </Box>
          <CustomTabPanel value={tabValue} index={0}>
            <ClaimsReceived tabValue={tabValue} />
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={1}>
            <ClaimsRaised tabValue={tabValue} />
          </CustomTabPanel>
        </Grid>
      </Grid>
    </>
  );
};

export default ContractManagementDashboard;
